import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { BehaviorSubject, catchError, Observable, of, tap, throwError } from "rxjs";
import { IBill } from "./ibill";

@Injectable({ providedIn: 'root' })
export class BillService {

    private _bill: BehaviorSubject<IBill | null> = new BehaviorSubject<IBill | null>(null);
    private _bills: BehaviorSubject<IBill[]> = new BehaviorSubject<IBill[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }


    get bill$(): Observable<IBill | null> {
        return this._bill.asObservable();
    }

    get bills$(): Observable<IBill[]> {
        return this._bills.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getBillDetailByOpdId(opdId: number) {
        return this._httpClient.get<BaseRespone<any>>(`${environment.baseURl}/Bill/${opdId}`).pipe(
            tap((response) => {
                this._bill.next(response.result);
            }),
            catchError((error) => {
                return throwError(() => error.error);
            })
        );
    }

    getBillDetailByIpdId(ipdId: number): Observable<BaseRespone<IBill[]>> {
        const url = `${environment.baseURl}/Bill/ipd/${ipdId}`;

        return this._httpClient.get<BaseRespone<IBill[]>>(url).pipe(
            tap((response: BaseRespone<IBill[]>) => {
                const bills = response.result;
                const hasBills = bills && bills.length > 0;
                const firstBill = hasBills ? bills[0] : null;
                this._bill.next(firstBill);
            }),
            catchError((error) => {
                console.error('Error fetching IPD bill details:', error);
                return throwError(() => error.error);
            })
        );
    }

    createBill(bill: IBill): Observable<BaseRespone<IBill>> {
        return this._httpClient.post<BaseRespone<IBill>>(`${environment.baseURl}/Bill`, bill).pipe(
            tap((response) => {
                this._bill.next(response.result);
            }),
            catchError((error) => {
                return of(error.error);
            })
        );
    }

    updateBill(bill: IBill): Observable<BaseRespone<IBill>> {
        return this._httpClient.put<BaseRespone<IBill>>(`${environment.baseURl}/Bill`, bill).pipe(
            tap((response) => {
                this._bill.next(response.result);
            }),
            catchError((error) => {
                return of(error.error);
            })
        );
    }

}
